export default __webpack_public_path__ + "media/images/quotemark-8d501b9fef489f83929e663a0816d3fa.svg";